export default __webpack_public_path__ + "static/media/ArtZines.195298a4.pdf";